import React from 'react';
import './InfoPage.css';

const Contact = () => {
  return (
    <div className="info-page">
      <div className="page-header">
        <p className="page-eyebrow">Support</p>
        <h1>We&apos;re Here to Help</h1>
        <p className="page-lede">
          Whether you have a technical question, want to report inaccurate credit data, or
          need help understanding a result, we respond quickly so you can stay focused on
          your goals.
        </p>
      </div>

      <div className="info-card">
        <h2 className="section-title">Get In Touch</h2>
        <p>
          For support or inquiries, you can reach out through our support channels.
          We're committed to helping VIT students with their CGPA calculations and
          providing accurate grade tracking tools.
        </p>
      </div>

      <div className="info-card">
        <h2 className="section-title">Response Time</h2>
        <ul>
          <li>Support requests: usually within 24 hours on weekdays.</li>
          <li>Bug reports with reproducible steps: typically acknowledged within one business day.</li>
          <li>Feature requests: we review weekly and share updates on our public roadmap.</li>
        </ul>
      </div>

      <div className="info-card">
        <h2 className="section-title">Report a Data Issue</h2>
        <p>
          CGPA rules and grade policies change over time. If you notice outdated grading
          scales or credit requirements, please include the semester, school, and official
          reference so we can update the calculator for everyone.
        </p>
      </div>

      <div className="info-card highlight-card">
        <h3>Accessibility Commitments</h3>
        <p>
          We continuously test keyboard navigation, color contrast, and responsive layouts.
          If you rely on assistive technology, let us know where we can do better and we will
          prioritize the fix.
        </p>
      </div>
    </div>
  );
};

export default Contact;
